import React from 'react';
import { isEmpty } from 'lodash';

// local dependencies
import { loadApi as loadMapApi } from 'utils/googleMapLoader';

// global dependency store
const dependencies = {
    google: null
};

/**
 * @desc This HOC loads third-party JavaScript dependencies asynchronously.
 * @example
 * import { withAsyncDependencies } from 'ui/hoc/withAsyncDependencies';
 */
const withAsyncDependencies = ( Component ) => {
    class WithAsyncDependencies extends React.Component {
        constructor( props ) {
            super( props );

            // component state
            this.state = {
                isLoading: true
            };

            // load async dependencies
            this.loadDependencies();
        }

        /**
         * @desc Loading asyn
         */
        loadDependencies() {
            log.debug( 'WithAsyncDependencies.loadDependencies()' );

            // load async dependencies which are missing from the global store
            Promise.all( [
                isEmpty( dependencies.google ) ? loadMapApi() : dependencies.google
            ] ).then( ( [ google ] ) => {

                // add dependencies to global store
                dependencies.google = google;

                // update state
                this.setState( {
                    isLoading: false
                } );
            } );
        }

        /**
         * @desc Render component
         */
        render() {
            return (
                <Component
                    { ...this.props }
                    isLoadingAsyncDependencies={ this.state.isLoading }
                    asyncDependencies={ dependencies }
                />
            );
        }
    }

    // set display name
    WithAsyncDependencies.displayName = 'WithAsyncDependencies';

    // set default props
    WithAsyncDependencies.defaultProps = {};

    // return class
    return WithAsyncDependencies;
};

export { withAsyncDependencies };
